<template>
  <div>
    <div
      class="tianyuanfifth"
      :style="{ backgroundImage: 'url(' + backImg + ')' }"
    >
      <div class="title_box">
        <div class="en">PRODUCT PERFORMANCE</div>
        <div class="zh">产品性能</div>
        <div class="line"></div>
      </div>
      <div class="table_box">
        <table width="100%">
          <tr class="tr_th">
            <th colspan="2">{{ projectName }}</th>
          </tr>
          <tr v-for="(item, index) in performance_content" :key="index">
            <td class="item_one">{{ item.one }}</td>
            <td class="item_two">{{ item.two }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    obj: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      backImg: "",
      performance_content: [],
      projectName: "",
    };
  },
  watch: {
    obj(val) {
      if (val.cate_id) {
        this.backImg = val.performance_background;
        this.performance_content = val.performance_content;
        this.projectName = val.name;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.tianyuanfifth {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .title_box {
    width: 100vw;
    height: 9.3vh;
    padding-top: 16vh;
    position: absolute;
    top: 0;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 2.8vh;
      color: rgba(255, 255, 255, 0.1);
      text-align: center;
      white-space: nowrap;
      width: 100%;
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      display: block;
      height: 5.8vh;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-top: -2vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .table_box {
    height: 37vh;
    width: 1200px;
    table {
      border-collapse: collapse;
      .tr_th {
        border: none;
      }
      tr {
        border-left: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        display: flex;
        th {
          width: 100%;
          // height: 50px;
          height: 5vh;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          // line-height: 50px;
          line-height: 5vh;
          color: #ffffff;
          text-align: left;
          background: rgba(15, 225, 225, 0.2);
          border: none;
          text-indent: 20px;
        }
        td {
          // height: 80px;
          height: 8vh;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 80px;
          line-height: 8vh;
          color: #ffffff;
          text-align: left;
          border-bottom: 1px solid #ffffff;
          text-indent: 20px;
          display: block;
        }
      }
      .item_one {
        width: 55% !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item_two {
        width: 45% !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>